import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

interface StockItem {
  id: number;
  name: string;
}

interface StockEntry {
  store_name: string;
  quantity: number;
  note?: string;
  created_at: string;
}

interface DrugIssue {
  patient_name: string;
  store_name: string;
  quantity: number;
  note?: string;
  created_at: string;
}

@Component({
  selector: 'app-product-log',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './product-log.html',
  styleUrls: ['./product-log.css']
})
export class ProductLogComponent implements OnInit {
  stockItems: StockItem[] = [];
  selectedId: number | null = null;
  productName = '';
  searchTerm: string = '';
  isDropdownOpen = false;

  logData = {
    entries: [] as StockEntry[],
    issues: [] as DrugIssue[]
  };

  startDate: string = '';
  endDate: string = '';

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchStockItems();
  }

  fetchStockItems() {
    this.http.get<StockItem[]>('https://logs.proofile.com.ng/api/stock-items').subscribe(data => {
      this.stockItems = data;
    });
  }

  get filteredStockItems(): StockItem[] {
    const term = this.searchTerm.toLowerCase();
    return this.stockItems.filter(item => item.name.toLowerCase().includes(term));
  }

  selectProduct(item: StockItem) {
    this.selectedId = item.id;
    this.productName = item.name;
    this.searchTerm = item.name;
    this.isDropdownOpen = false;
    this.fetchLogData();
  }

  fetchLogData() {
    if (!this.selectedId) return;

    this.http.get<any>(`https://logs.proofile.com.ng/api/productlog/${this.selectedId}`).subscribe(res => {
      this.logData.entries = res.entries || [];
      this.logData.issues = res.issues || [];
    });
  }

  onBlurDropdown() {
    setTimeout(() => {
      this.isDropdownOpen = false;
    }, 200);
  }

  isInDateRange(dateStr: string): boolean {
    const date = new Date(dateStr);
    const from = this.startDate ? new Date(this.startDate) : null;
    const to = this.endDate ? new Date(this.endDate) : null;

    return (!from || date >= from) && (!to || date <= to);
  }

  get filteredEntries(): StockEntry[] {
    return this.logData.entries.filter(entry => this.isInDateRange(entry.created_at));
  }

  get filteredIssues(): DrugIssue[] {
    return this.logData.issues.filter(issue => this.isInDateRange(issue.created_at));
  }
}
